import { freezeBody, unfreezeBody } from "./freezeScroll";

/* OVERLAY */

// get overlay & body
const body = document.querySelector("body");
const overlay = document.getElementById("overlay");
const overlayContent = document.getElementById("overlay__content");
const overlayClose = document.querySelector(".overlay__close");

// helper functions
const restoreBreaks = (content) => {
  return content.replace(/(?:\r\n|\r|\n)/g, "<br>");
};

var decodeEntities = (function () {
  // this prevents any overhead from creating the object each time
  var element = document.createElement("div");

  function decodeHTMLEntities(str) {
    if (str && typeof str === "string") {
      // strip script/html tags
      str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, "");
      str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, "");
      element.innerHTML = str;
      str = element.textContent;
      element.textContent = "";
    }

    return str;
  }

  return decodeHTMLEntities;
})();

openOverlayClick = (clickedItemId) => {
  console.log("openOverlayClick: " + clickedItemId);
  // find clicked item by id
  const clickedItem = document.getElementById(clickedItemId);
  if (clickedItem) {
    handleOverlay(clickedItem);
  }
};

const initOverlayLinks = () => {
  // get all overlay links
  const overlayLinks = document.querySelectorAll(".overlay-link");
  if (overlayLinks) {
    // get array from links
    const overlayLinkArray = Array.from(overlayLinks);
    // add event listener to all links
    overlayLinkArray.forEach((item) => {
      const thisItem = item;
      thisItem.addEventListener("click", (event) => {
        event.preventDefault();
        // add hashtag to url
        history.pushState({}, "", "#"+thisItem.id)
        // handle link
        handleOverlay(thisItem);
      });
    });
  }
};

// set overlay links and close events
if (overlay && overlayClose && overlayContent) {
  initOverlayLinks();

  // overlay close
  overlayClose.addEventListener("click", (event) => {
    event.preventDefault();
    history.pushState("", document.title, window.location.pathname+window.location.search);
    closeOverlay();
  });

  // end if( overlay )
}

// open and closes the overlay
const openOverlay = () => {
  body.classList.add("open-overlay");
  freezeBody();
};
const closeOverlay = () => {
  body.classList.remove("open-overlay");
  overlayContent ? (overlayContent.innerHTML = "") : null;
  unfreezeBody();
};

// handles overlays
const handleOverlay = (overlayLink) => {
  let overlayHtml = "";

  // set overlay data
  let overlayData = {
    type: overlayLink.dataset.overlayType,
  };

  // set extra data depending on type
  switch (overlayData.type) {
    case "events":
      overlayHtml = eventsOverlayHtml(overlayLink);
      break;
    case "discover":
      overlayHtml = discoverOverlayHtml(overlayLink, "content");
      break;
    case "discover-video":
      overlayHtml = discoverOverlayHtml(overlayLink, "video");
      break;
  }

  // set overlay HTML
  overlayContent.innerHTML = overlayHtml;
  // open overlay
  openOverlay();

  // execute after load, depending on type
  switch (overlayData.type) {
    case "events":
      break;
    case "discover":
      break;
  }
};

// Events Overlay
const eventsOverlayHtml = (overlayLink) => {
  // get link ID
  const overlayLinkId = overlayLink.getAttribute("id");
  // get content object based on the ID
  const contentObject = window[slugToCamelcase(overlayLinkId) + "Content"];
  // return event overlay HTML
  return `
    <div id="event-overlay" class="event-overlay">
        <div class="event-overlay__image bg-image" style="background-image:url(${
          contentObject.image
        });"></div>
        <h2 class="event-overlay__title article-heading">${
          contentObject.title
        }</h2>
        <h2 class="event-overlay__date article-sub-heading">${
          contentObject.date
        }</h2>
        <div class="body-copy wysiwyg"><p>${
          contentObject.content
        }</p></div>
        ${
          contentObject.link
            ? `<a href="${
                contentObject.link
              }" target="_blank" class="event-overlay__link arrow-cta arrow-cta--blue">${
                contentObject.linkLanguage
                  ? contentObject.linkLanguage
                  : "Learn More"
              }<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 570 1000"><polygon points="73 1000 0 927.3 424.8 500 0 72.7 73 0 570 500 "></polygon></svg></a>`
            : ``
        }
    </div>
    `;
};

const discoverOverlayHtml = (overlayLink, overlayType) => {
  // alert('discoverOverlayHtml');
  // get link ID
  const overlayLinkId = overlayLink.getAttribute("id");
  // get content object based on the ID
  const contentObject = window[slugToCamelcase(overlayLinkId) + "Content"];

  // get content element
  const contentElement = overlayLink.querySelector(
    ".featured_item-overlay-content"
  );
  // return discover overlay HTML
  /*
  // html for image div
  <div class="discover-overlay__image-div bg-image" style="display:none-;background-image:url(${ contentObject.overlayImage ? contentObject.overlayImage : contentObject.image });"></div>  
  */
  return `
    <div id="discover-overlay" class="discover-overlay discover-overlay--${overlayType}">
        ${
          overlayType == "content"
            ? `
            <div class="discover-overlay__image-wrapper">
              <img class="discover-overlay__image" src="${
                contentObject.overlayImage
                  ? contentObject.overlayImage
                  : contentObject.image
              }"/>
              </div>
              `
            : ``
        }
        <div class="discover-overlay__header">
            ${
              contentObject.title
                ? `<h2 class="discover-overlay__title article-heading">${contentObject.title}</h2>`
                : ``
            }
            ${
              contentObject.subtitle
                ? `<h2 class="discover-overlay__subtitle article-sub-heading">${contentObject.subtitle}</h2>`
                : ``
            }
            ${
              contentObject.content
                ? `<div class="discover-overlay__intro body-copy wysiwyg"><p>${contentObject.content}</p></div>`
                : ``
            }
            ${
              contentObject.smalltype
                ? `<div class="discover-overlay__smalltype body-copy body-copy--small">${contentObject.smalltype}</div>`
                : ``
            }
        </div>

        ${
          overlayType == "video" &&
          overlayLink.dataset.overlayVideoType == "upload"
            ? `
        <div class="discover-overlay__video-wrapper discover-overlay__video-wrapper--upload">
            <video class="discover-overlay__video" controls autoplay="autoplay">
                ${
                  overlayLink.dataset.overlayMp4
                    ? `<source src="${overlayLink.dataset.overlayMp4}" type="video/mp4">`
                    : ``
                }
            </video> 
        </div>
        `
            : ``
        }

        ${
          overlayType == "video" &&
          overlayLink.dataset.overlayVideoType == "vimeo"
            ? `
        <div class="discover-overlay__video-wrapper discover-overlay__video-wrapper--vimeo">
            <iframe class="discover-overlay__video" src="https://player.vimeo.com/video/${overlayLink.dataset.overlayVimeoId}?autoplay=1&title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
        </div>
        `
            : ``
        }

        <div class="body-copy wysiwyg">${
          contentObject.overlaycontent
        }</div>
        ${
          contentObject.link
            ? `<a href="${contentObject.link}" target="_blank" class="discover-overlay__link arrow-cta arrow-cta--blue">Learn More<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 570 1000"><polygon points="73 1000 0 927.3 424.8 500 0 72.7 73 0 570 500 "></polygon></svg></a>`
            : ``
        }
    </div>
    `;
};

function slugify(string) {
  // Replace quotes with an empty string
  string = string.replace(/[\'"’]+/g, '');

  // Convert to lowercase and replace non-alphanumeric characters with a hyphen
  string = string.replace(/[^A-Za-z0-9-]+/g, '-');

  // Remove leading and trailing hyphens
  string = string.replace(/^-+|-+$/g, '');

  return string.toLowerCase();
}

function slugToCamelcase(input) {
  // Split the input string by hyphens
  const words = input.split('-');

  // Capitalize the first letter of each word except the first one
  for (let i = 1; i < words.length; i++) {
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
  }

  // Join the words back together without spaces
  return words.join('');
}

function getTitleOrSubTitle(item) {
  var headingOrSub = item.title ? item.title : item.subtitle;
  // Check if headingOrSub starts with a number
  var match = headingOrSub.match(/^(\d+)/);
  if (match) {
      // Remove the number
      headingOrSub = headingOrSub.replace(match[1], '');
  }
  return slugify(headingOrSub);
}

export { initOverlayLinks, slugify, slugToCamelcase, handleOverlay, getTitleOrSubTitle };
